/* ============================================================
   BRUMA — Fiche produit pour Dawn (interactions)
   Charger une fois dans theme.liquid :
   {{ 'bruma-produit.js' | asset_url | script_tag }}
   (l'ajout au panier passe par le formulaire produit natif de Dawn)
   ============================================================ */
(function () {
  "use strict";

  function init() {
    /* ---------- Apparitions au scroll ---------- */
    var reveals = document.querySelectorAll(".bruma .reveal");
    if ("IntersectionObserver" in window && reveals.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add("in"); });
    }

    /* ---------- Galerie : miniatures -> image principale ---------- */
    var main = document.getElementById("galMain");
    var thumbs = document.getElementById("galThumbs");
    if (main && thumbs) {
      thumbs.addEventListener("click", function (e) {
        var btn = e.target.closest(".gthumb");
        if (!btn) return;
        var full = btn.getAttribute("data-full");
        if (!full) return;
        thumbs.querySelectorAll(".gthumb").forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
        var img = main.querySelector("img.bimg");
        if (!img) {
          var ph = main.querySelector(".bimg--ph");
          if (ph) ph.remove();
          img = document.createElement("img");
          img.className = "bimg";
          img.alt = "";
          main.appendChild(img);
        }
        img.src = full;
        img.animate([{ opacity: 0.4 }, { opacity: 1 }], { duration: 260, easing: "cubic-bezier(.2,.8,.2,1)" });
      });
    }

    /* ---------- Sélecteur de quantité ---------- */
    var qv = document.getElementById("qtyVal");
    var minus = document.getElementById("qtyMinus");
    var plus = document.getElementById("qtyPlus");
    function getQty() { var n = parseInt(qv.value, 10); return isNaN(n) || n < 1 ? 1 : n; }
    function setQty(n) { qv.value = Math.max(1, Math.min(99, n)); }
    if (qv && minus && plus) {
      minus.addEventListener("click", function () { setQty(getQty() - 1); });
      plus.addEventListener("click", function () { setQty(getQty() + 1); });
      qv.addEventListener("input", function () { qv.value = qv.value.replace(/[^0-9]/g, ""); });
      qv.addEventListener("blur", function () { setQty(getQty()); });
    }

    /* ---------- FAQ : un seul ouvert à la fois ---------- */
    var faqs = document.querySelectorAll(".bruma .faq .qa");
    faqs.forEach(function (d) {
      d.addEventListener("toggle", function () {
        if (d.open) faqs.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
